export default {"src":"/_next/static/media/loan_arrow2.0aede3e4.svg","height":510,"width":464,"blurWidth":0,"blurHeight":0};